var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarCustomerEvents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 44.732H12.6c-6.947 0-12.6-5.652-12.6-12.6V4.77h37.8a7.208 7.208 0 017.2 7.2v32.763zM3.6 8.366v23.766c0 4.963 4.037 9 9 9h28.8V11.97a3.604 3.604 0 00-3.6-3.6L3.6 8.366z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.065.034h-3.717v12.718h3.717V.034zM42.456 19.795v-3.717H2.544v3.717h39.913zM33.652.034h-3.717v12.718h3.717V.034z",
    fill: "#fff"
  })));
}
export default SvgCalendarCustomerEvents;